// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var TextCategory$ReactHooksTemplate = require("./textCategory.res.js");

function TextCategoryForm(props) {
  var disabled = props.disabled;
  var toggleModal = props.toggleModal;
  var onFormSubmit = props.onFormSubmit;
  var selectedTextCategory = props.selectedTextCategory;
  var llmEnabled = props.llmEnabled;
  var showDescription = props.showDescription;
  var match = React.useState(function (param) {
        return selectedTextCategory;
      });
  var setTextCategory = match[1];
  var textCategory = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setGeneratedDescription = match$1[1];
  var generatedDescription = match$1[0];
  var match$2 = React.useState(function (param) {
        return showDescription;
      });
  var setShowDescription = match$2[1];
  var handleNameChange = function ($$event) {
    var name = $$event.target.value;
    Curry._1(setTextCategory, (function (tc) {
            return TextCategory$ReactHooksTemplate.setName(tc, name);
          }));
  };
  var handleDescriptionChange = function ($$event) {
    var description = $$event.target.value;
    Curry._1(setTextCategory, (function (tc) {
            return TextCategory$ReactHooksTemplate.setDescription(tc, description);
          }));
  };
  var categoryNameLength = TextCategory$ReactHooksTemplate.name(textCategory).length;
  var tmp;
  if (match$2[0]) {
    var desc = TextCategory$ReactHooksTemplate.description(textCategory);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("label", {
                  children: "Description",
                  className: "block text-sm font-medium text-gray-700 mb-2"
                }),
            JsxRuntime.jsx("textarea", {
                  className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none",
                  maxLength: 200,
                  placeholder: "Enter category description",
                  rows: 3,
                  value: desc !== undefined ? desc : "",
                  onChange: handleDescriptionChange
                }),
            llmEnabled && categoryNameLength > 1 ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("button", {
                          children: [
                            JsxRuntime.jsx("span", {
                                  children: "✨",
                                  className: "mr-2"
                                }),
                            "Generate with AI"
                          ],
                          className: "inline-flex items-center px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white text-sm font-medium rounded-lg hover:from-purple-700 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all duration-200",
                          onClick: (function (param) {
                              var name = TextCategory$ReactHooksTemplate.name(textCategory);
                              var payload = {};
                              payload["name"] = name;
                              Js_promise.then_((function (response) {
                                      var status = Json_decode.field("status", (function (param) {
                                              return Json_decode.withDefault("failed", Json_decode.string, param);
                                            }), response);
                                      var newDescription = Json_decode.field("description", (function (param) {
                                              return Json_decode.optional(Json_decode.string, param);
                                            }), response);
                                      if (status === "success") {
                                        Curry._1(setGeneratedDescription, (function (param) {
                                                return newDescription;
                                              }));
                                      }
                                      return Promise.resolve();
                                    }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/text_categories/generate_description", payload));
                            })
                        }),
                    className: "flex justify-end"
                  }) : null,
            llmEnabled && generatedDescription !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "✨",
                                                  className: "text-sm"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: "AI Generated Description",
                                                  className: "text-xs font-medium text-blue-700"
                                                })
                                          ],
                                          className: "flex items-center space-x-2 mb-2"
                                        }),
                                    JsxRuntime.jsx("p", {
                                          children: generatedDescription,
                                          className: "text-sm text-gray-700"
                                        })
                                  ],
                                  className: "flex-1"
                                }),
                            className: "flex items-start justify-between"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: "Discard",
                                    className: "px-3 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200",
                                    onClick: (function (param) {
                                        Curry._1(setGeneratedDescription, (function (param) {
                                                
                                              }));
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: "Use This",
                                    className: "px-3 py-1 text-xs font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors duration-200",
                                    onClick: (function (param) {
                                        Curry._1(setTextCategory, (function (tc) {
                                                return TextCategory$ReactHooksTemplate.setDescription(tc, generatedDescription);
                                              }));
                                        Curry._1(setGeneratedDescription, (function (param) {
                                                
                                              }));
                                      })
                                  })
                            ],
                            className: "flex justify-end space-x-2 mt-3"
                          })
                    ],
                    className: "bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4"
                  }) : null,
            JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("img", {
                          className: "h-3 w-3 mr-2",
                          src: Image$ReactHooksTemplate.trash
                        }),
                    "Remove Description"
                  ],
                  className: "inline-flex items-center px-3 py-2 text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg hover:bg-red-100 transition-colors duration-200",
                  onClick: (function (param) {
                      Curry._1(setTextCategory, (function (tc) {
                              return TextCategory$ReactHooksTemplate.setDescription(tc, undefined);
                            }));
                      Curry._1(setShowDescription, (function (param) {
                              return false;
                            }));
                      Curry._1(setGeneratedDescription, (function (param) {
                              
                            }));
                    })
                })
          ],
          className: "space-y-3"
        });
  } else {
    tmp = JsxRuntime.jsxs("button", {
          children: [
            JsxRuntime.jsx("span", {
                  children: "+",
                  className: "mr-2"
                }),
            "Add Description"
          ],
          className: "inline-flex items-center px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors duration-200",
          onClick: (function (param) {
              Curry._1(setShowDescription, (function (param) {
                      return true;
                    }));
            })
        });
  }
  var buttonText = disabled ? "Delete Category" : "Save Category";
  var buttonStyles = disabled ? "bg-red-600 hover:bg-red-700 focus:ring-red-500" : "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500";
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("label", {
                                      children: "Name",
                                      className: "block text-sm font-medium text-gray-700 mb-2"
                                    }),
                                JsxRuntime.jsx("input", {
                                      className: "w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 " + (
                                        categoryNameLength === 0 ? "border-red-300" : "border-gray-300"
                                      ) + (
                                        disabled ? " bg-gray-100 cursor-not-allowed" : ""
                                      ),
                                      disabled: disabled,
                                      maxLength: 100,
                                      placeholder: "Enter category name",
                                      type: "text",
                                      value: TextCategory$ReactHooksTemplate.name(textCategory),
                                      onChange: handleNameChange
                                    }),
                                categoryNameLength === 0 ? JsxRuntime.jsx("p", {
                                        children: "Name can't be empty",
                                        className: "mt-1 text-xs text-red-600"
                                      }) : null
                              ]
                            }),
                        tmp
                      ],
                      className: "p-6 space-y-6"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Cancel",
                              className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                              onClick: (function (param) {
                                  Curry._1(toggleModal, undefined);
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: buttonText,
                              className: buttonStyles + " px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 transition-colors duration-200",
                              onClick: (function (param) {
                                  Curry._1(onFormSubmit, textCategory);
                                })
                            })
                      ],
                      className: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
                    })
              ],
              className: "flex flex-col"
            });
}

var make = TextCategoryForm;

exports.make = make;
/* react Not a pure module */
